<header class="sticky" [ngClass]="class" [class.fixed]="stick && sticky">
  <div class="mobile-fix-option"></div>
  <div class="top-header" *ngIf="topbar">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="header-contact">
            <ul>
              <li>Seja bem vindo a nossa loja Monkey Money</li>
              <li>
                <i class="fa fa-phone" aria-hidden="true"></i>Telefone: (31) 9
                9975-3052
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 text-end">
          <ul class="header-dropdown">
            <li class="mobile-wishlist" id="A" *ngIf="productService.location">
              <a (click)="resetValidateLocation()"
                ><i
                  class="fa fa-map-marker"
                  aria-hidden="true"
                  style="font-size: 15px"
                ></i>
                {{ productService.location }}
              </a>
            </li>

            <li class="mobile-wishlist">
              <a
                [routerLink]="['/shop/wishlist']"
                [ngStyle]="{ padding: usuarioLogado ? '5px' : '20px' }"
                ><i class="fa fa-heart" aria-hidden="true"></i>Lista de Desejos
              </a>
            </li>

            <li
              class="mobile-wishlist"
              style="margin-left: 0px; margin-right: 5px"
            >
              <a [routerLink]="['/pages/minhaconta']"
                ><i class="fa fa-user" aria-hidden="true"></i>Minha Conta
              </a>
            </li>

            <li class="mobile-wishlist" id="B" *ngIf="usuarioLogado != null">
              <a data-lng="es" type="button" (click)="fazerLogout()">
                <i class="fa fa-sign-out" aria-hidden="true"></i>
                Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-sm-12" id="HEADERR">
        <div class="main-menu">
          <div class="menu-left" style="max-width: 12%">
            <app-left-menu></app-left-menu>
            <div class="brand-logo">
              <a (click)="redirecionarHome()" id="headerlogo">
                <img [src]="themeLogo" class="img-fluid" alt="logo" />
              </a>
            </div>
          </div>
          <div class="menu-right pull-right">
            <div>
              <app-menu></app-menu>
            </div>
            <div>
              <app-settings></app-settings>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
